<template>
  <div>
    <p class="desc">选择能发起该审批的部门，不选则默认开放给所有人</p>
    <a-button @click="selectOrg" icon="plus" type="primary" shape="round">请选择部门</a-button>
    <org-items v-model="select"/>
    <dept-picker
      v-if="visible"
      multiple
      ref="orgPicker"
      :type="pickType"
      :selected="select"
      @ok="selected"
      @close="close"/>
  </div>
</template>

<script>
import DeptPicker from '@/components/common/DeptPicker'
import OrgItems from '../OrgItems'

export default {
  name: 'RootConfig',
  components: { DeptPicker, OrgItems },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      showOrgSelect: false,
      visible: false,
      pickType: 'dept'
    }
  },
  computed: {
    select () {
      return this.config.assignedUser
    }
  },
  methods: {
    selectOrg () {
      this.pickType = 'dept'
      this.visible = true
    },
    selected (select) {
      this.visible = false
      this.select.length = 0
      select.forEach(val => this.select.push(val))
    },
    close () {
      this.visible = false
    },
    removeOrgItem (index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.desc{
  font-size: small;
  color: #8c8c8c;
}
.org-item{
  margin: 5px;
}
</style>
